<template>
  <tabs
    :tab-name="tabs"
    :tab-icon="icons"
    nav-pills-icons
    color-button="primary"
  >
    <template
      v-for="(item, index) in tabData"
      :slot="'tab-pane-' + (index + 1)"
    >
      <component
        v-bind:is="item.comp"
        v-bind:tour="tour"
        :key="item.name"
      ></component>
    </template>
  </tabs>
</template>
<script>
import { Tabs } from "@/components";
import TourTabsDepartures from "./TourTabsDepartures.vue";
import TourTabsExtras from "./TourTabsExtras.vue";
import TourTabsPricing from "./TourTabsPricing.vue";
import TourTabsGuides from "./TourTabsGuides.vue";
import TourTabsEmail from "./TourTabsEmail.vue";
import TourTabsNotes from "./TourTabsNotes.vue";

import _filter from "lodash/filter";
import _map from "lodash/map";

export default {
  props: ["tour"],

  components: {
    Tabs,
    TourTabsDepartures,
    TourTabsExtras,
    TourTabsPricing,
    TourTabsGuides,
    TourTabsEmail,
    TourTabsNotes
  },

  computed: {
    tabData() {
      let data = [
        {
          name: "Departures",
          icon: "flight_takeoff",
          allowed: true,
          comp: "TourTabsDepartures"
        },
        {
          name: "Pricing",
          icon: "price_change",
          allowed: this.$allowed(["tour.price.manage", "tour.price.view.all"]),
          comp: "TourTabsPricing"
        },
        {
          name: "Extras",
          icon: "person_add_alt_1",
          allowed: this.$allowed(["tour.extra.manage", "tour.extra.view.all"]),
          comp: "TourTabsExtras"
        },
        {
          name: "Guides",
          icon: "explore",
          allowed: this.$allowed(["tour.guide.manage", "tour.guide.view.all"]),
          comp: "TourTabsGuides"
        },
        {
          name: "Email",
          icon: "alternate_email",
          allowed: this.$allowed(["tour.email.manage", "tour.email.view.all"]),
          comp: "TourTabsEmail"
        },
        {
          name: "Notes",
          icon: "text_snippet",
          allowed: this.$allowed(["note.tour.manage", "note.tour.view.all"]),
          comp: "TourTabsNotes"
        }
      ];
      return _filter(data, { allowed: true });
    },
    tabs() {
      return _map(this.tabData, "name");
    },
    icons() {
      return _map(this.tabData, "icon");
    }
  }
};
</script>
